// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function calculateRatio() {
  let _window = globalThis.window;
  if (_window !== undefined) {
    return Math.round(devicePixelRatio);
  } else {
    return 1.0;
  }
}

let get = calculateRatio;

exports.calculateRatio = calculateRatio;
exports.get = get;
/* No side effect */
